<script setup>
import {computed} from "vue";

const props = defineProps({
  number: {
    type: Number,
    required: true,
  },
});

const status = computed(() => {
  if (props.number < 0) {
    return 'decrease';
  }

  if (props.number > 0) {
    return 'increase';
  }

  return 'unchanged';
});
</script>

<template>
  <span
    class="tw-flex tw-items-center tw-justify-center tw-px-3 tw-py-1 tw-rounded-lg tw-text-xs tw-font-bold tw-gap-2"
    :class="{
      'tw-bg-pink-highlight tw-text-pink': status === 'decrease',
      'tw-bg-green-highlight tw-text-green': status === 'increase',
      'tw-bg-purple-highlight tw-text-purple': status === 'unchanged',
    }"
  >
    <svg-vue
      v-if="status === 'unchanged'"
      icon="icons/minus"
      class="tw-w-3"
    />
    <svg-vue
      v-else
      icon="icons/chevron"
      class="tw-w-2 tw-h-2"
      :class="{
        'tw-rotate-180': status === 'increase',
      }"
    />
    {{ Math.abs(number) }}
  </span>
</template>

